import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Card, CardContent } from '@material-ui/core';
import classNames from 'classnames';

import CircularProgress from '../CircularProgress';

import styles from './styles';

const useStyles = makeStyles(styles);

const CardWithProgressLoading = ({
  loading,
  fullHeight,
  children,
  disableShrinkProgress,
  className,
}) => {
  const classes = useStyles();

  return (
    <Card
      className={classNames(className, { [classes.fullHeight]: fullHeight })}
    >
      <CardContent>
        {loading ? (
          <CircularProgress disableShrink={disableShrinkProgress} />
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
};

CardWithProgressLoading.propTypes = {
  loading: PropTypes.bool,
  fullHeight: PropTypes.bool,
  children: PropTypes.node.isRequired,
  disableShrinkProgress: PropTypes.bool,
  className: PropTypes.string,
};

CardWithProgressLoading.defaultProps = {
  loading: true,
  fullHeight: true,
  disableShrinkProgress: false,
  className: null,
};

export default CardWithProgressLoading;
